import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { runTransaction } from "firebase/firestore";

import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  onIdTokenChanged,
  reload,
  sendPasswordResetEmail,
  signInWithCustomToken,
} from "firebase/auth";

import {
  doc,
  setDoc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  documentId,
  onSnapshot,
  serverTimestamp,
  updateDoc,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import { CHAMPIONSHIP_HOST } from "../common/constants";
import axios from "axios";
import algoliasearch from "algoliasearch/lite";
import moment from "moment";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyColSWEjL38TDBxdFJRmif9RUuhAQ8z0Kg",
  authDomain: "kongre-basvuru.firebaseapp.com",
  projectId: "kongre-basvuru",
  storageBucket: "kongre-basvuru.appspot.com",
  messagingSenderId: "556300997867",
  appId: "1:556300997867:web:f8d620ecdbb5ca02915aae",
  measurementId: "G-49LTGLYQY6",
};

const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);
const db = getFirestore(firebaseApp);

export const createAuthUser = async (email, pass, season) => {
  let user = {};
  const auth = getAuth();
  user = await createUserWithEmailAndPassword(auth, email, pass)
    .then((res) => {
      // sendVerificationEmail(res.user);
      setDoc(
        doc(db, "users", res.user.uid),
        {
          email,
          registration_season: season,
          role: "applicant",
          created_at: serverTimestamp(),
        },
        { merge: true }
      );

      return res.user;
    })
    .catch((error) => {
      if (error.code === "auth/email-already-in-use")
        alert(
          "Bu e-posta adresi ile daha önce kayıt yapılmış. Lütfen Giriş ekranından şifreniz ile giriş yapınız."
        );
    });
  return user;
};

export const listenUserAuthState = (userSetter) => {
  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    userSetter(user);
  });
};

// export const listenEmailVerificationStatus = (userSetter) => {
//   const auth = getAuth();
//   onIdTokenChanged(auth, (user) => {
//     console.log("id token değişti!!");
//     console.log("firebase methods listeneer verified user:", user);
//     userSetter(user);
//   });

// }

export const fbLogout = () => {
  const auth = getAuth();
  signOut(auth).then(
    function () {
      // Sign-out successful.
    },
    function (error) {
      alert("Logut esnasında hata oldu: ", error);
    }
  );
};

export const fbLogin = async (mail, pass) => {
  // firebase authentiocaton kullanarak kişinin o kişi olduğunu teyid ettikten sonra cloud sql'den kişiye ait detaylı bilgi çekeceğiz.
  const auth = getAuth();
  let res = "-";
  await signInWithEmailAndPassword(auth, mail, pass).catch((error) => {
    if (error.code === "auth/wrong-password") {
      res = "wrong_pass";
    } else {
      res = "email_not_found";
    } // Hatalara saçma sapan kodlar veriyorum ki hata bildiren kullanıcılar ekran görüntüsü attığında doğrudan kaynağı bulalım :)
  });

  return res;
};

export const loginWithMasterPass = async (email, pass, userSetter) => {
  // Süper şifre ile tüm hesaplara login olunabilir. Süper şifrenin ilk karakterleri oyunsüper, ama devamı da var, bu şifre firebase functions içinde config var olarak kayıtlı
  // Şifrenin ilk kısmı oyunsüper ise, email-şifre cloud functions'a gönderiliyor, orada şifrenin tamamı doğru mu diye kontrol ediliyor.
  // Şifre doğruysa cloud functions bir auth token üreterek client'a gönderiyor. Client bu tokeni kullanarak login oluyor.

  // const response = await axios.post('http://localhost:5001/oyun-5302a/us-central1/loginWithMasterPass',
  const response = await axios.post(
    "https://us-central1-kongre-basvuru.cloudfunctions.net/loginWithMasterPass",
    {
      email,
      pass,
    }
  );

  const token = response.data.token;
  const auth = getAuth();
  await signInWithCustomToken(auth, token)
    .then((userCredential) => {
      // Signed in
      let user = userCredential.user;
      userSetter(user);
      // ...
    })
    .catch((error) => {
      alert("HATA: Master password ile giriş başarısız!");
      // ...
    });
};

export const pullUserData = async (uid) => {
  const u = await getDoc(doc(db, "users", uid)).catch((e) => {
    alert("Bilgileriniz çekilirken hata meydana geldi!");
  });

  if (u && u.data()) {
    let activeSeasonReceipts = [];
    let coupon = null;

    let activeSeason = await fetchActiveSeason(u.data());

    if (activeSeason) {
      activeSeasonReceipts = await pullReceiptsByUser(u.id, activeSeason.id);
      coupon = await pullCoupons(u.data().email, activeSeason.id);
    }

    return { ...u.data(), uid: u.id, activeSeasonReceipts, coupon };
  } else return null;
};

export const findUserByEmail = async (email) => {
  const qry = query(collection(db, "users"), where("email", "==", email));
  const querySnapshot = await getDocs(qry);
  let users = [];
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    users.push({ ...doc.data(), id: doc.id });
  });
  return users?.[0];
};

export const pullCoupons = async (email, seasonId) => {
  const qry = query(
    collection(db, "coupons"),
    where("email", "==", email),
    where("season", "==", seasonId),
    where("is_used", "==", false)
  );
  const querySnapshot = await getDocs(qry);
  let coupon = null;
  querySnapshot.forEach((doc) => {
    // Birden fazla kupon tanımlanmışsa sadece en yüksek ücretli olanı dikkate alacağız:
    let c = { ...doc.data(), id: doc.id };
    if (coupon && c.amount < coupon.amount) return;
    coupon = c;
  });
  return coupon;
};
export const pullReceiptsByUser = async (userId, seasonId) => {
  const qry = query(
    collection(db, "receipts"),
    where("user_id", "==", userId),
    where("season_id", "==", seasonId),
    where("is_paid", "==", true)
  );
  const querySnapshot = await getDocs(qry);
  let receipts = [];
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    receipts.push({ ...doc.data(), id: doc.id });
  });
  return receipts;
};

export const listenReceiptsByUser = (userId, seasonId, callback) => {
  const qry = query(
    collection(db, "receipts"),
    where("user_id", "==", userId),
    where("season_id", "==", seasonId),
    where("is_paid", "==", true)
  );
  return onSnapshot(qry, (querySnapshot) => {
    const receipts = [];
    querySnapshot.forEach((docSnap) => {
      receipts.push({ ...docSnap.data(), id: docSnap.id });
    });
    callback(receipts);
  });
};

export const saveUserData = async (uid, data) => {
  await setDoc(doc(db, "users", uid), data, { merge: true });
};

export const listenActiveSeason = (callback, user) => {
  let qry = query(collection(db, "seasons"), where("is_active", "==", true));
  if (user?.role === "developer")
    qry = query(collection(db, "seasons"), where("is_developer_active", "==", true));

  return onSnapshot(qry, (querySnapshot) => {
    const activeSeasons = [];
    querySnapshot.forEach((docSnap) => {
      const season = docSnap.data();
      if (season.products) {
        Object.keys(season.products).forEach((pId) => {
          const product = season.products[pId];
          if (product.start_at) product.start_at = product.start_at.toDate().setMilliseconds(0);
          if (product.end_at)   product.end_at   = product.end_at.toDate().setMilliseconds(0);
        });
      }
      activeSeasons.push({ ...season, id: docSnap.id });
    });

    if (activeSeasons.length === 0) callback(null);
    else if (activeSeasons.length === 1) callback(activeSeasons[0]);
    else {
      alert("Aynı anda birden fazla aktif sezon olmamalı. Lütfen verileri kontrol ediniz!");
      callback(null);
    }
  });
};

export const fetchActiveSeason = async (user) => {
  let qry = query(collection(db, "seasons"), where("is_active", "==", true));
  if (user?.role === "developer")
    qry = query(
      collection(db, "seasons"),
      where("is_developer_active", "==", true)
    );
  const querySnapshot = await getDocs(qry);

  let activeSeasons = [];
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    let season = doc.data();
    if (season.products) {
      Object.keys(season.products).forEach((pId) => {
        let product = season.products[pId];
        if (product.start_at)
          product.start_at = product.start_at.toDate().setMilliseconds(0);
        if (product.end_at)
          product.end_at = product.end_at.toDate().setMilliseconds(0);
      });
    }

    activeSeasons.push({ ...season, id: doc.id });
  });

  if (activeSeasons.length === 0) return null;
  else if (activeSeasons.length === 1) {
    let activeSeason = activeSeasons[0];
    return activeSeason;
  } else {
    alert(
      "Aynı anda birden fazla aktif sezon olmamalı. Lütfen verileri kontrol ediniz!"
    );
    return null;
  }
};

export const getPayment = async (paymentToken) => {
  // const response = await axios.post( CHAMPIONSHIP_HOST + 'payments/check', { payment_token: paymentToken});
  const response = await axios.post(
    CHAMPIONSHIP_HOST + "receipts/check_purchase_with_payment_token",
    { payment_token: paymentToken }
  );

  return response?.data; //?.status === "successful";
};

export const checkPaymentWithCloudFunction = async (
  payment_token,
  zero_payment_object
) => {
  // if the price is zero no need to redirect to payment page
  //console.log("payment_token", payment_token);

  const response = await axios.post(
    "https://us-central1-kongre-basvuru.cloudfunctions.net/checkPayment",
    {
      payment_token,
      zero_payment_object: zero_payment_object,
    }
  );
  // console.log("response", response);

  return (
    response?.data?.result ||
    "Bir şeyler ters gitti. Lütfen profil sayfanıza dönerek sayfayı yenileyiniz."
  );
};

/*export const getPaymentUrl = async (params) => {
  //TODO: urun-teslim projesinde ödeme işlemlerini tozoş backendi olmadan yaptık. Oradan kopya çekerek düzelt.
  const response = await axios.post(
    CHAMPIONSHIP_HOST + "receipts/get_payment_url_for_kongre",
    { ...params }
  );

  return response?.data;
};*/

export const getPaymentUrl = async (params) => {
  const url = process.env.NODE_ENV === "development" 
    ? "/receipts/get_payment_url_for_kongre"
    : "https://championship-api.herokuapp.com/receipts/get_payment_url_for_kongre";
    
  const response = await axios.post(url, { ...params });
  return response?.data;
};

export const createReceipt = async (receipt) => {
  const user = getAuth().currentUser;
  const additionalReceiptFields = {
    user_id: user.uid,
    created_at: serverTimestamp(),
  };
  receipt = { ...receipt, ...additionalReceiptFields };
  const docRef = await addDoc(collection(db, "receipts"), receipt);
  return docRef.id;
};

export const createPaidReceiptForAnotherUser = async (receipt) => {
  const additionalReceiptFields = {
    created_at: serverTimestamp(),
    paid_at: serverTimestamp(),
    price: 0,
    token: "Toplu Ödeme",
    is_paid: true,
  };
  receipt = { ...receipt, ...additionalReceiptFields };
  const docRef = await addDoc(collection(db, "receipts"), receipt);

  return docRef.id;
};

export const decrementProductStock = async (seasonId, productId) => {
  const docRef = doc(db, "seasons", seasonId);
  const season = await getDoc(docRef);
  const product = season.data().products[productId];
  if (product.stock > 0) {
    product.stock = product.stock - 1;
    await setDoc(
      docRef,
      { products: { [productId]: product } },
      { merge: true }
    );
    return true;
  } else return false;
};


export const updateReceipt = async (receipt_id, receipt) => {
  const docRef = await updateDoc(doc(db, "receipts", receipt_id), receipt);
};

export const markPaymentAsSuccessful = async (userId, productId) => {
  const newData = { products: { [productId]: { is_paid: true } } };
  await saveUserData(userId, newData);
  return true;
};

export const sendVerificationEmail = (usr) => {
  const options = {
    url: window.location.origin + "/profile",
  };

  // console.log("options", options);

  const userForVerify = usr ? usr : getAuth().currentUser;
  // console.log("verification user:", userForVerify);
  sendEmailVerification(userForVerify, options).then(() => {
    // alert("Lütfen e-posta kutunuza giderek doğrulama linkine tıklayınız.");
  });
  // auth.user.sendEmailVerification().then(()=>{
  //   alert("Lütfen e-posta kutunuza giderek doğrulama linkine tıklayınız.");
  // });
  // sendEmailVerification(auth.user);
};

export const reloadAuthData = async (oldUser, setCentralState) => {
  let auth = getAuth();
  // reload(auth.currentUser);
  await auth.currentUser.reload();
  auth = getAuth();
  const currentUser = auth.currentUser;
  setCentralState({ user: { ...oldUser, ...currentUser } });
  if (!currentUser.emailVerified) {
    sendVerificationEmail(currentUser);
    alert("E-posta adresinizie doğrulama linki gönderilmiştir.");
  }
};

export const requestPasswordReset = (email) => {
  const auth = getAuth();
  return sendPasswordResetEmail(auth, email)
    .then(() => {
      return (
        email +
        " adresinize şifre sıfırlama linki gönderildi. Gelen kutunuzu kontrol ediniz."
      );
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      return "HATA: Sıfırlama maili gönderilemedi.";
    });
};

export const searchUsers = async (api_key, queryString) => {
  // Api key'i user tablosuna ekledim. Environment variable olmadığı için.
  const client = algoliasearch("ZVSICMBMEV", api_key);
  const index = client.initIndex("email_name_phone_kongre");

  const requestOptions = {
    // headers: { 'X-Algolia-UserToken': 'user123' }
  };

  let response = await index.search(queryString, requestOptions);
  // .then(({ hits }) => {
  //   console.log("HİTS: ", hits);
  // });
  return response?.hits || [];
};

export const adminChangesUserData = async (params) => {
  const { userId, competitorNewPass, emailVerified, newEmail } = params;
  let auth = getAuth();
  // const response = await axios.post('http://localhost:5001/oyun-5302a/us-central1/adminChangesUserData',

  if (!userId) {
    alert("HATA: User Id bilgisi verilmemiş!");
    return null;
  } else {
    let bodyParams = {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      cookies: {}, // TODO: Buraya ne gelecek bilmiyorum. Cookie'de saklanan değer varsa onu kullan gibi bir şey olacak galiba.
      competitorUid: userId,
      ...params,
    };

    const response = await axios.post(
      "https://us-central1-kongre-basvuru.cloudfunctions.net/adminChangesUserData",
      bodyParams
    );
    if (response.status === 200) return response.data.result;
    else return "HATA: Bilgiler güncellenirken birşeyler ters gitti.";
  }
};

export const verifyEmailManually = async (userId) => {
  let auth = getAuth();
  // const response = await axios.post('http://localhost:5001/oyun-5302a/us-central1/adminVerifiesUser',
  const response = await axios.post(
    "https://us-central1-oyun-5302a.cloudfunctions.net/adminVerifiesUser",
    {
      clientToken: "Bearer " + auth.currentUser.accessToken,
      cookies: {},
      competitorUid: userId,
    }
  );
  if (response.status === 200) return response.data.result;
  else return "HATA: e-posta doğrulaması yapılırken birşeyler ters gitti.";
};

export const readStats = async () => {
  const stats = await getDoc(doc(db, "stats", "oyun2026"));
  return stats.data();
};

export const doSmth = async (params) => {
  const season2025 = {
    products: {
      // "2025_01_burak_karabey": {
      //   product_type: 2,
      //   price: 750,
      //   stock: 100,
      //   title: "",
      //   start_at: new Date("2025-10-26T10:00:00"),
      //   end_at: new Date("2025-10-26T11:30:00"),
      //   room: "Çok Amaçlı Salon",
      //   moderator: "Doç. Dr. Burak Karabey",
      // },

      "2025_02_mustafa_serdar_koksal": {
        product_type: 2,
        price: 750,
        stock: 50,
        title:
          "Üstün Zekalı Çocukların Belirlenmesi ve Evde Eğitimlerinin Desteklenmesi",
        start_at: new Date("2025-10-26T12:00:00"),
        end_at: new Date("2025-10-26T13:30:00"),
        room: "Çok Amaçlı Salon",
        moderator: "Prof. Dr. Mustafa Serdar Köksal",
      },

      "2025_13_ozge_karabulut": {
        product_type: 2,
        price: 750,
        stock: 25,
        title: "Belirsizlikte Adaptif Zekâ ile İlerlemek",
        start_at: new Date("2025-10-26T10:00:00"),
        end_at: new Date("2025-10-26T11:30:00"),
        room: "Çok Amaçlı Salon",
        moderator: "M. Özge Karabulut",
      },

      // "2025_08_sinem_kolcak": {
      //   product_type: 2,
      //   price: 750,
      //   stock: 25,
      //   title: "",
      //   start_at: new Date("2025-10-26T12:00:00"),
      //   end_at: new Date("2025-10-26T13:30:00"),
      //   room: "EFD13",
      //   moderator: "Sinem Kolçak",
      // },
    },
  };

  const docRef = await setDoc(doc(db, "seasons", "season_2025"), season2025, {
    merge: true,
  });
};

const markMultiplePaymentsAsSuccessful = async () => {
  const emails = [
    // "black-pearl6@hotmail.com",
    // "dumansevgi91@gmail.com",
    // "sevgiduran_26_1991@hotmail.com",
    // "alecgsfatih@hotmail.com",
    // "yucelgov@hotmail.com",
    // "burakdogan12@gmail.com",
    // "osmanihsan26@gmail.com",
    // "eteroglu@gmail.com",
    // "dr.comer@gmail.com",
    // "mnkrtl@gmail.com",
    // "aygulcal@hotmail.com",
    // "esracetinkayaengin@gmail.com",
    // "rusen2662@gmail.com",
    // "niyazi_uyar84@hotmail.com",
    // "melgoshnar@gmail.com",
    // "paramedik-d@hotmail.com",
    // "dt.didem@gmail.com",
    // "mandaciticaret@gmail.com",
    // "sekufe.kalkan@metu.edu.tr",
    // "hpolat1998@yahoo.com",
    // "defnebayatli2010@gmail.com",
    // "andincserap@gmail.com",
    // "kubrayuksel26@gmail.com",
    // "canyilmaz5361@hotmail.com",
    // "baykaloguzkaan@gmail.com",
    // "fatmasaglamlar@gmail.com",
    // "muzafferd@gmail.com",
    "mandaciengin26@gmail.com",
    // "hpolat@gmail.com",
    // "sekufekalkan26@gmail.com",
  ];

  let kayitsizlar = [];
  let ids = [];
  for (let i = 0; i < emails.length; i++) {
    const email = emails[i].trim();
    const qry = query(collection(db, "users"), where("email", "==", email));
    const querySnapshot = await getDocs(qry);
    if (querySnapshot.docs.length === 0) kayitsizlar.push(email);
    else {
      const docId = querySnapshot.docs[0].id;
      ids.push(docId);
      await markPaymentAsSuccessful(docId, "oyun2022");
    }
  }

  //console.log("kayitsizlar", kayitsizlar);
  //console.log("ids", ids);
};

// export const getAllUsers = async () => {
//   let users = [];
//   const ss = await getDocs(query(collection(db, "users")));
//   if (ss?.docs) {
//     ss.docs.forEach((doc) => {
//       let id = doc.id;
//       let data = doc.data();
//       // eğer created_at varsa onu da toDate() ile date objesine çevir, moment ile de 2023-09-11... şeklinde stringe çevir.
//       users.push({ ...data, id });
//     });
//   }

//   return users;
// };

export const getAllUsers = async () => {
  let users = [];
  const ss = await getDocs(query(collection(db, "users")));

  if (ss?.docs) {
    ss.docs.forEach((doc) => {
      let id = doc.id;
      let data = doc.data();

      if (
        ["season_2023", "season_2024", "season_2025", "season_2026"].includes(
          data.registration_season
        )
      ) {
        users.push({ ...data, id });
      }
    });
  }

  return users;
};

export const getPaidReceiptsBySeason = async (seasonId = "season_2026") => {
  // paid_at üzerinde aralık filtresi yok: paid_at alanı olmayan (elle işaretlenmiş) makbuzlar da gelsin.
  const qry = query(
    collection(db, "receipts"),
    where("season_id", "==", seasonId),
    where("is_paid", "==", true)
  );

  const querySnapshot = await getDocs(qry);
  let receipts = [];
  querySnapshot.forEach((doc) => {
    receipts.push({ ...doc.data(), id: doc.id });
  });
  return receipts;
};

function arrayToCsv(data, filename) {
  let content = data
    .map(
      (row) =>
        row
          .map(String) // convert every value to String
          .map((v) => v.replaceAll('"', '""')) // escape double colons
          .map((v) => v.replaceAll("undefined", ""))
          .map((v) => `"${v}"`) // quote it
          .join(",") // comma-separated
    )
    .join("\r\n"); // rows starting on new lines

  var blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  var url = URL.createObjectURL(blob);

  // Create a link to download it
  var pom = document.createElement("a");
  pom.href = url;
  pom.setAttribute("download", filename);
  pom.click();

  alert("indi");
}

// const addPaidReceiptsToUsers = async () => {
//   const emails = [];
//   for (const email of emails) {
//     const newPaidReceipt= {

//   }
// }

export const createCouponByEmail = async (email, seasonId, data) => {
  const coupon = {
    ...data,
    email,
    season: seasonId,
    is_used: false,
    receipt_id: "",
    created_at: serverTimestamp(),
  };
  const docRef = doc(collection(db, "coupons"));
  const couponDoc = await setDoc(docRef, coupon, {
    merge: true,
  });
  return docRef.id;
};

export const getAllCoupons = async (seasonId) => {
  const querySnapshot = await getDocs(
    query(collection(db, "coupons"), where("season", "==", seasonId))
  );
  return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const deleteCoupon = async (couponId) => {
  await deleteDoc(doc(db, "coupons", couponId));
};
const toIstanbulDateKey = (date) =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Istanbul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);

export const getUserStatistics = async () => {
  const todayKey = toIstanbulDateKey(new Date());
  let usersToday = 0;
  let totalUsers = 0;
  let seasonProducts = [];
  let kongreKatilimCount = 0;
  let digerUrunlerCount = 0;
  let kongreToday = 0;
  let workshopToday = 0;
  let dailyMap = {};

  const newDailyRow = (dateKey) => ({
    date: dateKey,
    users: 0,
    kongreSold: 0,
    workshopSold: 0,
    revenue: 0,
    purchases: [], // { email, products: [başlık], price, paidMs }
  });

  const bumpDaily = (dateKey, field, amount = 1) => {
    if (!dailyMap[dateKey]) {
      dailyMap[dateKey] = newDailyRow(dateKey);
    }
    dailyMap[dateKey][field] += amount;
  };

  const ss = await getDocs(
    query(
      collection(db, "users"),
      where("registration_season", "in", [
        "season_2023",
        "season_2024",
        "season_2025",
        "season_2026",
      ])
    )
  );

  const payment = await getDocs(
    query(
      collection(db, "receipts"),
      where("season_id", "==", "season_2026"),
      where("is_paid", "==", true)
    )
  );

  let productTitles = {};
  const seasonDoc = await getDoc(doc(db, "seasons", "season_2026"));
  if (seasonDoc.exists()) {
    const seasonData = seasonDoc.data();
    Object.entries(seasonData.products ?? {}).forEach(([pid, p]) => {
      productTitles[pid] = p?.title ?? pid;
    });
    // console.log(seasonData);

    // products alanının nesne olduğunu kontrol et
    if (seasonData.products && typeof seasonData.products === "object") {
      // Ürünleri nesneden diziye dönüştür
      seasonProducts = Object.values(seasonData.products).map((product) => ({
        title: product.title,
        stock: product.stock,
        price: product.price,
        room: product.room,
        total_stock: product.total_stock,
        closed: product.is_closed === true,
      }));
    } else {
      console.error(
        "seasonData.products bir nesne değil veya tanımlı değil:",
        seasonData.products
      );
    }
  }

  if (ss?.docs) {
    ss.docs.forEach((doc) => {
      let data = doc.data();

      if (data.created_at) {
        const dateKey = toIstanbulDateKey(data.created_at.toDate());

        if (dateKey === todayKey) {
          usersToday++;
        }

        bumpDaily(dateKey, "users");
      }

      totalUsers++;
    });
  }

  if (payment?.docs) {
    payment.docs.forEach((doc) => {
      let data = doc.data();
      const productIds = Object.keys(data.receipt_products ?? {}).filter(
        (pid) => data.receipt_products[pid]
      );
      const kongreSold = productIds.includes("2026_00_kongre_katilim") ? 1 : 0;
      const workshopSold = productIds.length - kongreSold; // makbuzdaki atölye adedi

      kongreKatilimCount += kongreSold;
      digerUrunlerCount += workshopSold;

      const paidDate = data.paid_at ?? data.created_at;
      if (!paidDate) return; // tarihi hiç olmayan makbuz günlük tabloya giremez
      const dateKey = toIstanbulDateKey(paidDate.toDate());
      if (dateKey === todayKey) {
        kongreToday += kongreSold;
        workshopToday += workshopSold;
      }
      bumpDaily(dateKey, "kongreSold", kongreSold);
      bumpDaily(dateKey, "workshopSold", workshopSold);
      bumpDaily(dateKey, "revenue", data.price ?? 0);
      dailyMap[dateKey].purchases.push({
        id: doc.id,
        email: data.email ?? "—",
        // kongre önce, sonra atölyeler
        products: [...productIds]
          .sort((a, b) => (b === "2026_00_kongre_katilim") - (a === "2026_00_kongre_katilim"))
          .map((pid) => ({ id: pid, title: productTitles[pid] ?? pid, isKongre: pid === "2026_00_kongre_katilim" })),
        price: data.price ?? 0,
        paidMs: paidDate.toDate().getTime(),
        byGroup: !!data.paid_by_group,
        paidByEmail: data.paid_by_email ?? null,
        isGroupPayer: !!data.group_receipt_id && !data.paid_by_group, // toplu ödemeyi yapan kişinin kendi makbuzu
      });
    });
  }
  const rangeStart = moment("2026-08-10", "YYYY-MM-DD");
  const rangeEnd = moment.min(moment("2026-11-06", "YYYY-MM-DD"), moment(todayKey, "YYYY-MM-DD"));
  const dailyStats = [];
  for (let d = rangeStart.clone(); d.isSameOrBefore(rangeEnd); d.add(1, "day")) {
    const dateKey = d.format("YYYY-MM-DD");
    const row = dailyMap[dateKey] ?? newDailyRow(dateKey);
    row.purchases.sort((a, b) => b.paidMs - a.paidMs);
    dailyStats.push(row);
  }
  dailyStats.reverse();

  return {
    todayUsers: usersToday,
    totalUsers: totalUsers,
    kongreToday: kongreToday,
    workshopToday: workshopToday,
    kongreKatilimCount: kongreKatilimCount,
    digerUrunlerCount: digerUrunlerCount,
    seasonProducts: seasonProducts,
    dailyStats: dailyStats,
  };
};

/**
 * "Kontrol" sekmesi için:
 *  - groupPayers: birden fazla kişiyi kapsayan toplu ödeme yapanlar (kimleri ve hangi atölyeleri ödediğiyle)
 *  - multiWorkshopUsers: ödenmiş makbuzlarında toplam 2+ atölye olan kişiler (atölye adlarıyla)
 *  - workshopOptions: filtre için atölye adları
 *
 * group_receipts koleksiyonu admin için okunamadığından (rules) sadece receipts okunur:
 * toplu ödemede her üyenin makbuzu aynı group_receipt_id'yi ve ödeyenin uid'ini (created_by) taşır.
 */
export const getControlStats = async (seasonId = "season_2026") => {
  const KONGRE_ID = "2026_00_kongre_katilim";

  const [receiptSnap, seasonDoc] = await Promise.all([
    getDocs(
      query(
        collection(db, "receipts"),
        where("season_id", "==", seasonId),
        where("is_paid", "==", true)
      )
    ),
    getDoc(doc(db, "seasons", seasonId)),
  ]);

  const seasonProducts = seasonDoc.exists() ? seasonDoc.data().products ?? {} : {};
  // Firestore Timestamp → ms (diğer yerlerdeki season dönüşümüyle aynı)
  const toMs = (t) => (t?.toDate ? t.toDate().setMilliseconds(0) : t ?? null);
  const workshopOf = (pid) => ({
    id: pid,
    title: seasonProducts[pid]?.title ?? pid,
    start_at: toMs(seasonProducts[pid]?.start_at),
    end_at: toMs(seasonProducts[pid]?.end_at),
  });
  const startMs = (w) => (w.start_at ? moment(w.start_at).valueOf() : Infinity);
  const byStart = (a, b) => startMs(a) - startMs(b) || a.title.localeCompare(b.title, "tr");
  const workshopIdsOf = (data) =>
    Object.keys(data.receipt_products ?? {}).filter(
      (pid) => data.receipt_products[pid] && pid !== KONGRE_ID
    );

  const receipts = receiptSnap.docs.map((d) => ({ id: d.id, ...d.data() }));

  // ── Birden çok atölye alanlar ──
  const workshopsByUser = {};
  receipts.forEach((r) => {
    const ids = workshopIdsOf(r);
    if (ids.length === 0) return;
    const key = r.user_id ?? r.email ?? r.id;
    if (!workshopsByUser[key]) {
      workshopsByUser[key] = { key, email: r.email ?? "—", workshops: [], boughtByOthers: false };
    }
    const u = workshopsByUser[key];
    ids.forEach((pid) => {
      if (!u.workshops.some((w) => w.id === pid)) u.workshops.push(workshopOf(pid));
    });
    if (r.paid_by_group) u.boughtByOthers = true;
  });
  const multiWorkshopUsers = Object.values(workshopsByUser)
    .map((u) => ({ ...u, workshops: [...u.workshops].sort(byStart), count: u.workshops.length }))
    .filter((u) => u.count > 1)
    .sort((a, b) => b.count - a.count || a.email.localeCompare(b.email));

  // ── Toplu ödeme yapanlar ──
  const groups = {}; // group_receipt_id → { payerKey, email, members: [] }
  receipts.forEach((r) => {
    if (!r.group_receipt_id) return;
    const g = (groups[r.group_receipt_id] ??= {
      payerKey: r.created_by ?? r.paid_by_email ?? r.group_receipt_id,
      email: "—",
      members: [],
    });
    const isPayer = !!r.user_id && r.user_id === r.created_by;
    if (r.paid_by_email) g.email = r.paid_by_email; // ödeyenin kendi makbuzunda bu alan null
    else if (isPayer && r.email && g.email === "—") g.email = r.email;
    g.members.push({
      email: r.email ?? "—",
      isPayer,
      hasKongre: !!r.receipt_products?.[KONGRE_ID],
      workshops: workshopIdsOf(r).map(workshopOf).sort(byStart),
    });
  });

  const payers = {};
  Object.values(groups).forEach((g) => {
    if (g.members.length <= 1) return;
    const p = (payers[g.payerKey] ??= { key: g.payerKey, email: g.email, groupCount: 0, members: [] });
    p.groupCount += 1;
    if (p.email === "—") p.email = g.email;
    p.members.push(...g.members);
  });
  const groupPayers = Object.values(payers)
    .map((p) => ({ ...p, memberCount: p.members.length }))
    .sort((a, b) => b.memberCount - a.memberCount || a.email.localeCompare(b.email));

  const workshopOptions = Array.from(
    new Set(Object.values(seasonProducts).filter((p) => p.product_type !== 1).map((p) => p.title))
  ).sort((a, b) => a.localeCompare(b, "tr"));

  return { groupPayers, multiWorkshopUsers, workshopOptions };
};

export const getPaidReceiptsWithoutPaidAt = async () => {
  // Tüm is_paid: true olan receipt'leri getir
  const qry = query(
    collection(db, "receipts"),
    where("is_paid", "==", true)
  );

  const querySnapshot = await getDocs(qry);
  let receiptsWithoutPaidAt = [];

  querySnapshot.forEach((doc) => {
    let data = doc.data();
    
    // paid_at alanı yoksa veya null/undefined ise bu kaydı ekle
    if (!data.paid_at) {
      receiptsWithoutPaidAt.push({
        id: doc.id,
        ...data,
        created_at: data.created_at ? data.created_at.toDate() : null,
        paid_at: data.paid_at ? data.paid_at.toDate() : null
      });
    }
  });

  return receiptsWithoutPaidAt;
};

export const exportPaidReceiptsWithoutPaidAtToExcel = async () => {
  try {
    const receipts = await getPaidReceiptsWithoutPaidAt();
    
    if (receipts.length === 0) {
      alert("İşlenmiş ama paid_at olmayan receipt bulunamadı.");
      return;
    }

    // Excel için veri formatını hazırla
    const excelData = receipts.map((receipt, index) => [
      index + 1,
      receipt.id || "",
      receipt.user_id || "",
      receipt.season_id || "",
      receipt.price || 0,
      receipt.token || "",
      receipt.is_paid ? "Evet" : "Hayır",
      receipt.created_at ? moment(receipt.created_at).format("DD/MM/YYYY HH:mm:ss") : "",
      receipt.paid_at ? moment(receipt.paid_at).format("DD/MM/YYYY HH:mm:ss") : "YOK",
      receipt.receipt_products ? JSON.stringify(receipt.receipt_products) : "",
      receipt.email || "",
      receipt.name || "",
      receipt.phone || ""
    ]);

    // Başlık satırı ekle
    const headers = [
      "Sıra No",
      "Receipt ID",
      "User ID", 
      "Season ID",
      "Fiyat",
      "Token",
      "Ödendi",
      "Oluşturulma Tarihi",
      "Ödeme Tarihi",
      "Ürünler",
      "E-posta",
      "İsim",
      "Telefon"
    ];

    const allData = [headers, ...excelData];

    // CSV formatında indir
    arrayToCsv(allData, `paid_receipts_without_paid_at_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`);
    
    alert(`${receipts.length} adet işlenmiş ama paid_at olmayan receipt Excel dosyası olarak indirildi.`);
    
  } catch (error) {
    console.error("Excel export hatası:", error);
    alert("Excel dosyası oluşturulurken hata oluştu: " + error.message);
  }
}; 

export const createReceiptForUser = async (receipt) => {
  const payer = getAuth().currentUser;
  const data = {
    ...receipt,
    created_at: serverTimestamp(),
    created_by: payer.uid,
  };
  const docRef = await addDoc(collection(db, "receipts"), data);
  return docRef.id;
};
 
export const createGroupReceipt = async (groupReceiptData) => {
  const payer = getAuth().currentUser;
  const data = {
    ...groupReceiptData,
    payer_id: payer.uid,
    created_at: serverTimestamp(),
  };
  const docRef = await addDoc(collection(db, "group_receipts"), data);
  return docRef.id;
};
 
export const updateGroupReceipt = async (group_receipt_id, data) => {
  await updateDoc(doc(db, "group_receipts", group_receipt_id), data);
};
 
// firebaseMethods.js — yeni fonksiyon ekle
export const markGroupReceiptAsPaid = async (groupReceiptId) => {
  // 1. group_receipt'i çek
  const groupDoc = await getDoc(doc(db, "group_receipts", groupReceiptId));
  if (!groupDoc.exists()) throw new Error("Group receipt bulunamadı.");
  
  const groupData = groupDoc.data();

  // 2. Her üyenin receipt'ini is_paid: true yap
  for (const mr of groupData.members || []) {
    await updateDoc(doc(db, "receipts", mr.receipt_id), {
      is_paid: true,
      paid_at: serverTimestamp(),
    });
  }

  // 3. payer receipt'ini de güncelle
  if (groupData.payer_receipt_id) {
    await updateDoc(doc(db, "receipts", groupData.payer_receipt_id), {
      is_paid: true,
      paid_at: serverTimestamp(),
    });
  }

  // 4. group_receipt'i kapat
  await updateDoc(doc(db, "group_receipts", groupReceiptId), {
    is_paid: true,
    paid_at: serverTimestamp(),
  });
};

export const getGroupReceiptIdByPayerReceiptId = async (payerReceiptId) => {
  const receiptDoc = await getDoc(doc(db, "receipts", payerReceiptId));
  if (!receiptDoc.exists()) return null;
  return receiptDoc.data()?.group_receipt_id || null;
};

export const getUserPaidProducts = async (targetEmail, seasonId) => {
  const fns = getFunctions();
  const fn = httpsCallable(fns, "getUserPaidProducts");
  const result = await fn({ targetEmail, seasonId });
  return result.data;
};

// Bilet (QR) maili. params: { mode: "test" | "send", seasonId, testEmail?, onlyEmail?, skipEmails?, limit? }
// Dönen: { sent, failed: [{email, name, error}], remaining, total }
export const sendBadgeMails = async (params) => {
  const fn = httpsCallable(getFunctions(), "sendBadgeMails");
  const result = await fn(params);
  return result.data;
};

// Giriş yapmış kullanıcının kendi bileti. Dönen: { eligible, code?, image? (data URL) }
export const getMyBadge = async () => {
  const fn = httpsCallable(getFunctions(), "getMyBadge");
  const result = await fn();
  return result.data;
};

// Girişte bilet okutma (gizli link anahtarı gateKey ya da admin). params: { gateKey, payload } veya { seasonId, manualCode }
// Dönen: { status: "ok" | "already" | "invalid", code, name, workshops, checkedInAt }
export const checkInBadge = async (params) => {
  const fn = httpsCallable(getFunctions(), "checkInBadge");
  const result = await fn(params);
  return result.data;
};

// ─────────────────────────────────────────────────────────────────────────────
// firebaseMethods.js'e eklenecek 2 yeni fonksiyon
// Mevcut import satırlarına şunları ekleyin:
//   import { doc, setDoc, collection, getDocs, getDoc } from "firebase/firestore";
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Firestore'daki tüm season dökümanlarını çeker.
 * @returns {Promise<Array<{id: string, ...}>>}
 */
export const getAllSeasons = async () => {
  const snapshot = await getDocs(collection(db, "seasons"));
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};

/**
 * Mevcut bir sezonu kopyalayarak yeni ID ile Firestore'a kaydeder.
 *
 * Yapılanlar:
 *  - Kaynak sezondaki tüm ürünleri, fiyatları ve alanları kopyalar.
 *  - Ürün ID'lerinin başındaki yılı yeni sezon ID'sindeki yılla değiştirir.
 *    (Örn: "2025_01_ahmet" → "2026_01_ahmet")
 *  - Her ürünün stoğunu total_stock değerine sıfırlar.
 *  - is_active ve is_developer_active alanlarını false yapar.
 *
 * @param {string} sourceSeasonId  - Kopyalanacak sezon (örn. "season_2025")
 * @param {string} newSeasonId     - Oluşturulacak sezon (örn. "season_2026")
 */
export const cloneSeasonById = async (sourceSeasonId, newSeasonId) => {
  const sourceRef  = doc(db, "seasons", sourceSeasonId);
  const sourceSnap = await getDoc(sourceRef);

  if (!sourceSnap.exists()) {
    throw new Error("Kaynak sezon bulunamadı: " + sourceSeasonId);
  }

  const sourceData = sourceSnap.data();
  const newYear    = newSeasonId.replace("season_", "");

  // Ürün ID'lerindeki yılı değiştir ve stokları sıfırla
  const freshProducts = {};
  if (sourceData.products) {
    Object.entries(sourceData.products).forEach(([pid, product]) => {
      const newPid = pid.replace(/^\d{4}_/, `${newYear}_`);
      freshProducts[newPid] = {
        ...product,
        stock: product.total_stock ?? product.stock ?? 0, // stoğu sıfırla
      };
    });
  }

  await setDoc(doc(db, "seasons", newSeasonId), {
    ...sourceData,
    products:             freshProducts,
    is_active:            false,
    is_developer_active:  false,
  });
};

/**
 * Bir atölye (ürün) için "satın alanlardan TC Kimlik No iste" ayarını açar/kapatır.
 * seasons/{seasonId}.products.{productId}.requires_tc alanını günceller.
 */
export const setProductRequiresTc = async (seasonId, productId, value) => {
  await updateDoc(doc(db, "seasons", seasonId), {
    [`products.${productId}.requires_tc`]: !!value,
  });
};

/**
 * Bir atölyeyi "wifi isteyen atölye" olarak işaretler/işareti kaldırır.
 * seasons/{seasonId}.products.{productId}.requires_wifi alanını günceller.
 */
export const setProductRequiresWifi = async (seasonId, productId, value) => {
  await updateDoc(doc(db, "seasons", seasonId), {
    [`products.${productId}.requires_wifi`]: !!value,
  });
};

/**
 * Bir atölyeyi satışa kapatır/açar (stoğa dokunmaz).
 * seasons/{seasonId}.products.{productId}.is_closed alanını günceller.
 */
export const setProductClosed = async (seasonId, productId, value) => {
  await updateDoc(doc(db, "seasons", seasonId), {
    [`products.${productId}.is_closed`]: !!value,
  });
};

/**
 * Verilen ürünlerin güncel stoklarını kontrol eder, hiçbir şey değiştirmez.
 * productCounts: { [productId]: kacAdetIsteniyor }
 * Yetersiz olanları döner. Boş dizi = hepsi yeterli.
 */
export const getUserNamesByIds = async (userIds) => {
  if (!userIds.length) return {};
  const map = {};
  for (let i = 0; i < userIds.length; i += 10) {
    const chunk = userIds.slice(i, i + 10);
    const snap = await getDocs(query(collection(db, "users"), where(documentId(), "in", chunk)));
    snap.forEach((d) => { map[d.id] = d.data().name ?? ""; });
  }
  return map;
};

export const getUsersByIds = async (userIds) => {
  if (!userIds.length) return {};
  const map = {};
  for (let i = 0; i < userIds.length; i += 10) {
    const chunk = userIds.slice(i, i + 10);
    const snap = await getDocs(query(collection(db, "users"), where(documentId(), "in", chunk)));
    snap.forEach((d) => { map[d.id] = { ...d.data(), id: d.id }; });
  }
  return map;
};

export const getReceiptsBySeasonId = async (seasonId) => {
  const qry = query(
    collection(db, "receipts"),
    where("season_id", "==", seasonId),
    where("is_paid", "==", true)
  );
  const querySnapshot = await getDocs(qry);
  const receipts = [];
  querySnapshot.forEach((d) => receipts.push({ ...d.data(), id: d.id }));
  return receipts;
};

export const checkStockAvailability = async (seasonId, productCounts) => {
  const seasonRef = doc(db, "seasons", seasonId);
  const seasonSnap = await getDoc(seasonRef);
  if (!seasonSnap.exists()) throw new Error("Sezon bulunamadı.");

  const products = seasonSnap.data().products || {};

  const insufficient = [];

  Object.entries(productCounts).forEach(([pId, qty]) => {
    const product = products[pId];
    if (!product) return;
    const currentStock = product.is_closed === true ? 0 : (product.stock ?? 0);
    if (currentStock < qty) {
      insufficient.push({ id: pId, title: product.title, available: currentStock, requested: qty });
    }
  });

  return insufficient;
};

// Yanlışlıkla işaretlenen girişi geri alır. payload: QR içeriği. Dönen: { ok }
export const undoCheckInBadge = async (payload, gateKey) => {
  const fn = httpsCallable(getFunctions(), "undoCheckInBadge");
  const result = await fn({ payload, gateKey });
  return result.data;
};

// Kongre bileti alan herkesin kodunu/QR'ını mail atmadan önce üretir (admin). Dönen: { created, existing, total }
export const generateBadges = async (seasonId) => {
  const fn = httpsCallable(getFunctions(), "generateBadges");
  const result = await fn({ seasonId });
  return result.data;
};

// Bilet listesi (admin, Excel için). Dönen: { rows: [{ code, name, email, workshops, qrPayload, sentAt, checkedInAt }] }
export const listBadges = async (seasonId) => {
  const fn = httpsCallable(getFunctions(), "listBadges");
  const result = await fn({ seasonId });
  return result.data;
};

// Admin: kullanıcının ödenmiş atölyesini başka atölyeyle değiştirir. params: { seasonId, userId, fromProductId, toProductId, force? }
export const adminChangeWorkshop = async (params) => {
  const fn = httpsCallable(getFunctions(), "adminChangeWorkshop");
  const result = await fn(params);
  return result.data;
};

// Admin: kullanıcının sezondaki tüm ödenmiş kayıtlarını başka kullanıcıya aktarır. params: { seasonId, fromUserId, toUserId }
export const adminTransferRegistration = async (params) => {
  const fn = httpsCallable(getFunctions(), "adminTransferRegistration");
  const result = await fn(params);
  return result.data;
};
